import React from "react";
import logo from "../logo.jpeg"; // Replace with your SBR logo
import "./HomeValues.css";

const values = [
  { letter: "S", word: "Supportive", description: "We guide you through every step with care." },
  { letter: "B", word: "Brilliant", description: "Expert advice and smart property solutions." },
  { letter: "R", word: "Responsive", description: "Always ready to help and answer your queries." },
];

const HomeValues = () => {
  return (
    <section className="home-values-section">
      <div className="logo-container">
        <img src={logo} alt="SBR Logo" />
      </div>

      <div className="values-container">
        {values.map((item, index) => (
          <div key={index} className="value-card">
            <div className="value-letter">{item.letter}</div>
            <h3 className="value-word">{item.word}</h3>
            <p className="value-description">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeValues;